import { twMerge } from 'tailwind-merge';

import type { IDividerProps } from './IDividerProps';

const Divider = ({ className, wrapperClassName, ...rest }: IDividerProps) => {
  return (
    <div className={twMerge('relative', wrapperClassName)}>
      <div className="absolute inset-0 flex items-center" aria-hidden="true">
        <div
          className={twMerge('w-full border-t border-secondary-200', className)}
          {...rest}
        />
      </div>
    </div>
  );
};

export default Divider;
